import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import { multiTabsData } from "../../../global/utils/multiTabData";
import {
  laboGrupo,
  wsGetLaboCentros,
} from "../../context/Actions/laboGrupo/laboGrupo";
import { estudioGrupo, filtrarEstudioGrupoPorEdad } from "../../context/Actions/estudioGrupo/estudioGrupo";
import LaboratorioTxt from "./LaboratorioTxt";
import {
  LimpiarSelectGlobal,
  LimpiarSelectL,
  SelectUserGlobal,
  SelectUserL,
} from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import { showModal } from "../../context/Actions/modal/modal";
import { setOrigenMultitab } from "../../context/Actions/multiTab/multiTab";
import { logoutLaboTurnos } from "../../context/Actions/turnos/laboTurnos";
import BurguerMobile from "../../components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../components/Genericos/HeaderbarHome/HeaderbarHome";
import Modal from "../../components/Genericos/Modal/Modal";
import Sidebar from "../../components/Genericos/Sidebar/Sidebar";
import TituloSaludo from "../../components/Genericos/TituloSaludo/TituloSaludo";
import ToasterV2 from "../../../global/component/Genericos/Toaster/ToasterV2";
import BuscadorLaboratorio from "../../components/Turnos/BuscadorLaboratorio/BuscadorLaboratorio";
import MultitabHome from "../../components/Turnos/MultitabHome/MultitabHome";
import MultitabMobile from "../../components/Turnos/MultitabMobile/MultitabMobile";
import Loading from "../../components/Genericos/Loading/Loading";
import "./Laboratorio.css";
import SegundoModal from "../../components/Genericos/SegundoModal/SegundoModal";
import { finalizaTurnosDisponibles } from "../../context/Actions/turnos/turnosDisponibles";
import { GlobalContext } from "../../../global/context/Provider";
import routes from "_+_Portal/routes/listRoutes";
import BuscadorTurnos from "../BuscadorTurnos/BuscadorTurnos";
import { wsGetTextos } from "_+_Portal/context/Actions/textos/textos";
import { showToaster } from "global/context/action/toaster/toaster";
import { pageContainerVariants } from "global/utils/cardAnimation";
import { motion } from "framer-motion";
import HeaderTitle from "_+_Portal/components/Genericos/HeaderTitle/HeaderTitle";
import BottomNavbar from "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar";
import "_+_Portal/components/Genericos/BottomNavbar/BottomNavbar.css";

const Laboratorio = () => {
  const history = useHistory();
  const {
    estudioGrupoDispatch,
    estudioGrupoState,
    modalState,
    turnosDisponiblesDispatch,
    laboGrupoDispatch,
    laboGrupoState,
    multiTabState,
    selectDropDownDispatch,
    modalDispatch,
    multiTabDispatch,
    segundoModalState,
    turnosDisponiblesState,
    laboTurnosDispatch,
    textosDispatch,
    listaFamiliaresState,
    selectDropDownState,
  } = useContext(PortalContext);

  // Nuevo contexto
  const { authState, toasterState, toasterDispatch, configState } =
    useContext(GlobalContext);

  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const [tabsData, setTabsData] = useState(multiTabsData);
  const widthWindow = window.innerWidth;
  const esMobile = widthWindow <= 768;

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };

  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };

  const onClickMultitabHome = (e) => {
    if (configState.config.data.opcBuscadorTurnos) {
      const index = routes.findIndex((objeto) => objeto.id === 30);
      if (index === -1) {
        routes.push({
          id: 30,
          path: "/buscadorTurnos",
          component: BuscadorTurnos,
          title: "Buscador Turnos",
          needsAuth: false,
        });
      }
    }
    setOrigenMultitab(null)(multiTabDispatch);
    history.push(e.path);
  };

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data === null) {
      estudioGrupo(authState?.auth?.data?.paciente)(estudioGrupoDispatch);
    }
    if (
      laboGrupoState.laboGrupo.data === null &&
      configState.config.data?.opcLaboratorio
    ) {
      laboGrupo()(laboGrupoDispatch);
    }
    if (
      laboGrupoState.laboGrupo.centros === null &&
      configState.config.data?.opcLaboratorio
    ) {
      wsGetLaboCentros()(laboGrupoDispatch);
    }
    if (
      turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
      "LABORATORIO"
    ) {
      logoutLaboTurnos()(laboTurnosDispatch);
      finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
    }

    //eslint-disable-next-line
  }, [configState.config.data]);

  useEffect(() => {
    //complemento textos siempre lo ultimo
    wsGetTextos()(textosDispatch);
  }, []);

  // Setear familiar desde URL (hash con parámetro familiar)
  useEffect(() => {
    const familiarDNI = sessionStorage.getItem("familiarHash");

    if (
      familiarDNI &&
      listaFamiliaresState.listaFamiliares.data &&
      !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
    ) {
      const familiarEncontrado = listaFamiliaresState.listaFamiliares.data.find(
        (fam) => fam.paciente?.nro_documento === familiarDNI,
      );

      if (familiarEncontrado) {
        if (familiarEncontrado.tipoDerecho?.manejoTurnos) {
          // Setear el familiar en el contexto
          SelectUserL({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          SelectUserGlobal({
            id: familiarEncontrado.id,
            paciente: familiarEncontrado.paciente,
          })(selectDropDownDispatch);
          // Filtrar grupos de estudio por edad del familiar
          filtrarEstudioGrupoPorEdad(
            estudioGrupoState.estudioGrupo.dataOriginal,
            familiarEncontrado.paciente
          )(estudioGrupoDispatch);

          // Limpiar sessionStorage después de usar
          sessionStorage.removeItem("familiarHash");
        } else {
          // Familiar sin permisos
          showToaster(
            {
              texto: "El familiar no tiene permisos para gestionar turnos.",
              tipo: "warning",
            },
            "centroArriba",
          )(toasterDispatch);
          sessionStorage.removeItem("familiarHash");
        }
      } else {
        // Familiar no encontrado
        showToaster(
          {
            texto: "No se encontró el familiar especificado.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);
        sessionStorage.removeItem("familiarHash");
      }
    }
    //eslint-disable-next-line
  }, [listaFamiliaresState.listaFamiliares.data]);

  // ONCHANGE DROPDOWN
  const onChangeMultitabMobile = (e) => {
    const dataOriginal = estudioGrupoState.estudioGrupo.dataOriginal;
    
    if (e !== "") {
      if (
        e.id &&
        e.id !== authState.auth.data.paciente.codigo &&
        e.manejoTurnos
      ) {
        SelectUserL({ id: e.id, paciente: e.paciente })(selectDropDownDispatch);
        SelectUserGlobal({ id: e.id, paciente: e.paciente })(
          selectDropDownDispatch,
        );
        filtrarEstudioGrupoPorEdad(dataOriginal, e.paciente)(estudioGrupoDispatch);
      } else if (e.id !== authState.auth.data.paciente.codigo) {
        showToaster(
          {
            texto: "No posees permisos para gestionar turnos de este familiar.",
            tipo: "warning",
          },
          "centroArriba",
        )(toasterDispatch);

        LimpiarSelectL()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
      } else {
        LimpiarSelectL()(selectDropDownDispatch);
        LimpiarSelectGlobal()(selectDropDownDispatch);
        filtrarEstudioGrupoPorEdad(dataOriginal, authState?.auth?.data?.paciente)(estudioGrupoDispatch);
      }
    } else {
      LimpiarSelectL()(selectDropDownDispatch);
    }
  };

  useEffect(() => {
    if (configState.config.data !== null) {
      let tabsAux = tabsData;
      if (configState.config.data.opcLaboratorio === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 2);
      }
      if (configState.config.data.opcRecetaDigital === false) {
        tabsAux = tabsAux.filter((i) => i.id !== 3);
      }
      if (
        configState.config.data.opcRecetaDigital === false &&
        configState.config.data.opcLaboratorio === false &&
        configState.config.data.opcBuscadorTurnos === false
      ) {
        tabsAux = tabsAux.filter((i) => i.id !== 3 && i.id !== 2);
      }
      if (configState.config.data.opcBuscadorTurnos) {
        tabsAux = tabsAux.filter((i) => i.id !== 0 && i.id !== 1 && i.id !== 2);
      } else {
        tabsAux = tabsAux.filter((i) => i.id !== 5);
      }
      setTabsData(tabsAux);
    }
  }, [configState.config.data]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      {toasterState.toaster.show && <ToasterV2 />}
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <Loading
        dataLoading={
          estudioGrupoState.estudioGrupo.loading ||
          estudioGrupoState.estudioGrupo.data === null
        }
        color="c-white"
        descripcion={
          (estudioGrupoState.estudioGrupo.loading &&
            "Cargando laboratorio...") ||
          (estudioGrupoState.estudioGrupo.data === null &&
            "Cargando laboratorio...")
        }
      />
      <HeaderbarHome onShowBurguerHandle={onShowBurguerHandle} />
      <HeaderTitle title={"Laboratorio"} />

      {/* <MultitabMobile
        posicionMultitab={
          multiTabState.multiTab.origen !== null &&
          multiTabState.multiTab.origen !== undefined
            ? multiTabState.multiTab.origen
            : 2
        }
        onChangeMultitabMobile={onChangeMultitabMobile}
        type={"LABO"}
      /> */}
      <motion.div
        variants={pageContainerVariants(esMobile)}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {estudioGrupoState.estudioGrupo.data && (
          <div className="ptur-bodyContainer-Laboratorio with-bottom-navbar">
            <Sidebar />
            <div className="ptur-laboratorio-container">
              <TituloSaludo />
              <div className="ptur-laboratorio-buscador">
                <MultitabHome tabs={tabsData} onClick={onClickMultitabHome} />
                {laboGrupoState.laboGrupo.data !== null && (
                  <BuscadorLaboratorio
                    onChangeMultitabMobile={onChangeMultitabMobile}
                  />
                )}
                <LaboratorioTxt />
              </div>
            </div>
          </div>
        )}
      </motion.div>

      {/* Bottom Navbar - Solo visible en móviles */}
      {esMobile && <BottomNavbar />}
    </React.Fragment>
  );
};

export default Laboratorio;
